import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import MC from './mv_1080.mp4';
import './mc.scss';
import Spinner from 'components/Spinner';

export const VirtualMC = ({ isPlaying, audioRef, isLoading }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const { isCallBot } = useSelector((state) => state);
  // eslint-disable-next-line no-unused-vars
  const [isShowLoading, setIsShowLoading] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const audio = audioRef?.current;

    if (!canvas || !video) return;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    if (!isPlaying) {
      video.pause();
      cancelAnimationFrame(animationRef.current);
      return;
    }

    video.src = MC;
    video.crossOrigin = 'anonymous';

    video.oncanplay = async () => {
      try {
        // Cập nhật size canvas đúng kích thước video
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        await video.play();
        removeGreenScreen();
      } catch (err) {
        console.error('Lỗi phát video:', err);
      }
    };

    function removeGreenScreen() {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let frame = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let data = frame.data;

      for (let i = 0; i < data.length; i += 4) {
        let r = data[i],
          g = data[i + 1],
          b = data[i + 2];

        if (g > 100 && r < 100 && b < 100) {
          data[i + 3] = 0; // loại bỏ nền xanh
        }
      }

      ctx.putImageData(frame, 0, 0);
      animationRef.current = requestAnimationFrame(removeGreenScreen);
    }

    // Dừng video khi audio kết thúc
    const handleAudioEnded = () => {
      video.pause();
      cancelAnimationFrame(animationRef.current);
    };

    if (audio) {
      audio.addEventListener('ended', handleAudioEnded);
    }

    return () => {
      cancelAnimationFrame(animationRef.current);
      if (audio) {
        audio.removeEventListener('ended', handleAudioEnded);
      }
    };
  }, [isPlaying, audioRef]);

  // Delay loading spinner (nếu cần)
  useEffect(() => {
    const timeOut =
      isCallBot && setTimeout(() => setIsShowLoading(false), 1000);
    return () => clearTimeout(timeOut);
  }, [isCallBot]);

  return (
    <div className={`v_mc`}>
      <>
        {isLoading && <Spinner />}
        <video ref={videoRef} muted loop style={{ display: 'none' }} />
        <canvas ref={canvasRef} />
      </>
    </div>
  );
};
